import React from 'react';
import { CpuIcon, TrendingUpIcon, CrosshairIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg relative overflow-hidden" data-id="element-41">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-42" />

      <div className="max-w-5xl mx-auto text-center space-y-12 relative z-10" data-id="element-43">
        <div className="space-y-4" data-id="element-44">
          <h2 className="text-4xl md:text-5xl text-brand-gold" data-id="element-45">
            La Ingeniería Inversa de Cuotas
          </h2>
          <p className="text-xl text-brand-text max-w-3xl mx-auto leading-relaxed" data-id="element-46">
            Esto no es un libro de predicciones ni picks mágicos. Es un sistema
            paso a paso para entender cómo funcionan las cuotas… y encontrar
            oportunidades donde otros solo ven riesgo.
          </p>
        </div>

        <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12 shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-47">
          <p className="text-lg md:text-xl text-brand-muted leading-relaxed mb-10" data-id="element-48">
            Vas a aprender a identificar cuándo la casa de apuestas se equivoca
            y cómo aprovechar esas oportunidades con lógica, no con suerte.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-49">
            <div className="flex flex-col items-center text-center space-y-4" data-id="element-50">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-51">
                <CpuIcon className="w-8 h-8 text-brand-gold" data-id="element-52" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-53">📊 DATOS REALES</h3>
              <p className="text-brand-faint text-sm" data-id="element-54">
                Deja de mirar solo resultados. Aprende a interpretar
                estadísticas que realmente importan (como xG).
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-55">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-56">
                <TrendingUpIcon className="w-8 h-8 text-brand-gold" data-id="element-57" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-58">📈 VALOR DE MERCADO</h3>
              <p className="text-brand-faint text-sm" data-id="element-59">
                Descubre cuándo una cuota está mal calculada… y dónde está la
                ventaja.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-60">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-61">
                <CrosshairIcon className="w-8 h-8 text-brand-gold" data-id="element-62" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-63">🧠 CONTEXTO REAL</h3>
              <p className="text-brand-faint text-sm" data-id="element-64">
                Lesiones, motivación, fatiga… factores que la mayoría ignora y
                que cambian todo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}